import * as Application from 'expo-application';
import { randomUUID as uuidv4 } from 'expo-crypto';

import { isAndroid, isIos, mmkvStorage } from 'utils/environment';

// get from mmkv if it exists there since this is fastest
let deviceId = mmkvStorage.getString('deviceId');

// normal way to get deviceId except for certain circumstances
export const getDeviceId = () => deviceId;

// might be async on the first time app is ever started on iOS, we use MMKV afterwards
export const getDeviceIdAsync = async (): Promise<string> => {
  if (deviceId) {
    return deviceId;
  }

  if (isIos) {
    const iosId = await Application.getIosIdForVendorAsync();
    deviceId = iosId || '';
  } else if (isAndroid) {
    const androidId = Application.getAndroidId();
    deviceId = androidId || '';
  } else {
    // expo removed support from this for web so keep it the same as it was in prior SDK versions
    const KEY_NAME = 'EXPO_CONSTANTS_INSTALLATION_ID';

    const id = localStorage.getItem(KEY_NAME);
    if (id) {
      deviceId = id;
    } else {
      const uuid = uuidv4();
      localStorage.setItem(KEY_NAME, uuid);
      deviceId = uuid;
    }
  }
  deviceId = deviceId.toLowerCase();
  mmkvStorage.set('deviceId', deviceId);
  return deviceId;
};

// get this as soon as possible and make all ios code wait for one call to it since it has been observed to take 1s to come back!
// noop outside of iOS
getDeviceIdAsync();
